import * as Sentry from "@sentry/react";
import { getAppState } from "../state";
import { sendSentryErrorReport } from "../errors/utils";

const excludeSentryLogPages = ["series", "movies"];
export const handleStorageEvent = async event => {
  event.preventDefault();
  event.stopPropagation();
  let field = `storageField_${event.key.replace("credentials", "Cred")}`;
  let action = "field changed";
  if (event.oldValue == null) action = "Field Created";
  if (event.newValue == null) action = "Field Removed";
  let status = "Normal State";
  let sa = event.storageArea;
  let credentials = sa.credentials == null ? "" : sa.credentials;
  let state = sa.state == null ? "" : sa.state;
  let error = false;
  //console.log(`credentials:${credentials} state:${state}`);
  if (credentials == "" && state == "LoggedIn") {
    status = "Abnormal state - Credentials either not found or altered - user could be in logged out state now.";
    error = true;
  }
  if (credentials != "" && state == "LoggedOut") {
    status = "Abnormal state - Credentials either not found or altered - user could be in logged out state now.";
    error = true;
  }
  let customEvent = {
    field: field,
    action: action,
    status: status,
    error: error
  };
  if (event.key == "state" || event.key == "credentials") {
    customEvent.newValue = event.newValue == null ? " " : event.newValue;
    customEvent.oldValue = event.oldValue == null ? " " : event.oldValue;
    customEvent.url = event.url;
  }
  const eventMsg = {
    message: `Credentails Changed - ${status}`,
    level: error ? "error" : "info",
    user: { id: event.storageArea.globalUserId },
    tags: { environment: "test" },
    extra: customEvent
  };
  captureEvent(eventMsg);
  //console.log("result", eventMsg);
};
export const updateLocalStorage = (key, newValue, action) => {
  const oldValue = localStorage.getItem(key);
  if (action === "Add") localStorage.setItem(key, newValue);
  else localStorage.removeItem(key, newValue);
  const storageEvent = new StorageEvent("storage", {
    key: key,
    oldValue: oldValue,
    newValue: newValue ? newValue : " ",
    url: window.location.href,
    storageArea: localStorage
  });
  window.dispatchEvent(storageEvent);
};
export const captureEvent = eventMsg => {
  const commonMsg = {
    time: new Date().toUTCString(),
    location: getAppState().country
  };
  const eventMessage = {
    ...eventMsg,
    extra: {
      ...eventMsg.extra,
      ...commonMsg
    }
  };
  console.log("Sentry + Splunk Event:", eventMessage);
  const errObj = {
    event: "LocalStorage",
    status: "info",
    errorName: "localStorageLog",
    parameter: { ...eventMessage }
  };
  sendSentryErrorReport(errObj);
  //console.log("eventMessage", eventMessage);
  // sending to sentry
  Sentry.captureEvent(eventMessage);
};
export const formattedTokenForLogger = token => {
  const beginningToken = (token && token.substring(0, 50)) || "";
  const endToken = (token && token.substring(token.length - 20)) || "";
  return beginningToken + "........................." + endToken;
};

export const SentrycaptureError = error => {
  if (error instanceof Error) {
    Sentry.captureException(error);
  }
};

export const getPageRouteName = url => {
  const parsedUrl = new URL(url);
  const pathArray = parsedUrl.pathname.split("/");
  return pathArray[1];
};

export const isFromContentDetailsPath = url => {
  const containsExcludedPath = excludeSentryLogPages.some(path => url.includes(`/${path}/`));
  return containsExcludedPath;
};
